import Store from '@/store/index'

export const authGuard = (to, from, next) => {
    const currentUser = Store.getters.isAuthUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if(requiresAuth && !currentUser){
        // N-291 (4A): al login, apuntando a dónde iba; el login vuelve allí.
        next({ path: '/', query: { redirect: to.fullPath } });
    } else{
        next();
    }
}
